<template>
    <van-steps direction="vertical" :active="0">
        <div>
            <van-step v-for="(item, index) in list" :key="item.id || index">
                <h4>审核类型：{{ item.auditType | filterAuditType }}</h4>
                <h4>审核结果：{{ item.auditStatus | filterAuditStatus }}</h4>
                <h4>处理人：{{ item.auditPerson }}</h4>
                <div style="font-weight: bold" v-html="item.auditRemark|replaceNewlines"></div>
                <p style="font-weight: bold">{{ item.createDateStr }}</p>
            </van-step>
        </div>
    </van-steps>
</template>

<script>

  import { getComments } from '@/api/loanInfo'

  export default {
    name: 'records',
    components: {

    },
    props: {
      applyId: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        list: []
      }
    },
    mounted () {
      this.initData()
    },
    methods: {
      initData () {
        let params = {
          applyId: this.applyId
        }
        getComments(params).then(res => {
            if(!!res.data){
                this.list = res.data
                console.log(this.list)
            }

        })
      }
    }
  }
</script>

<style scoped>

</style>
